import useTranslation from "next-translate/useTranslation";
import dynamic from "next/dynamic";
import { Suspense, useEffect, useState } from "react";
// import BienTypeSelect from "./components/BienTypeSelect";
// import PriceRangeSelect from "./components/PriceRangeSelect";
// import SurfaceRangeSelect from "./components/SurfaceRangeSelect";
// import TypologieSelect from "./components/TypologieSelect";
// import CaracteristicSelect from "./components/CaracteristicSelect";
// import FiltersDialog from "./components/FiltersDialog";
import { RootState } from "types/RootState";
// import TransactionTypeSelect from "./components/TransactionTypeSelect";
import { useDispatch, useSelector } from "react-redux";
import {
  actions as ListingreducerActions,
  selectors as ListingsReducerSelectors,
} from "redux/slices/v2/ListingReducer";
import SearchBarStyle from "./SearchBar.module.scss";
import PlacesAutoCompleteInput from "./components/PlacesAutoComplete";

import { useRouter } from "next/router";
import nookies from "nookies";
import {
  setAuthenticated,
  setEmail,
  setUID,
  setUser as setUserDispatch,
  signInR,
  updateUser,
} from "redux/slices/authReducer";
import { checkUserClientSide } from "utils/BackendHelper";
import {
  actions as UserSpaceActions,
  selectors as UserSpaceSelectors,
} from "../../../../redux/slices/v2/UserSpace";

const FiltersDialog = dynamic(() => import("./components/FiltersDialog"), {
  suspense: true,
  ssr: true,
});
const TransactionTypeSelect = dynamic(
  () => import("./components/TransactionTypeSelect"),
  {
    suspense: true,
    ssr: true,
  }
);

const BienTypeSelect = dynamic(() => import("./components/BienTypeSelect"), {
  suspense: true,
  ssr: true,
});
const PriceRangeSelect = dynamic(
  () => import("./components/PriceRangeSelect"),
  {
    suspense: true,
    ssr: true,
  }
);
const SurfaceRangeSelect = dynamic(
  () => import("./components/SurfaceRangeSelect"),
  {
    suspense: true,
    ssr: true,
  }
);
const TypologieSelect = dynamic(() => import("./components/TypologieSelect"), {
  suspense: true,
  ssr: true,
});

const VoirPlusSelect = dynamic(() => import("./components/VoirPlusSelect"), {
  suspense: true,
  ssr: true,
});

const SaveSearch = dynamic(() => import("./components/SaveSearch"), {
  suspense: true,
  ssr: true,
});

export default function SearchbarComponent({
  transactionType,
  onTransactionTypeChange,
  onPlaceSearchResult,
  onMapSearchParamsChange,
  onTypesSelected,
  onMeubleeChange,
  onPriceRangeChange,
  onSurfaceRangeChange,
  onTypologieSelect,
  onCaracteristicsSelect,
  onPlacesAutoCompleteGeolocatePress,
  onBulkFiltersChange,
  totalListingsCount,
  onMapVsListChange,
  openAuth,
  scrollY,
  mapVsList,
}: {
  transactionType: "Vente" | "Location" | "Projets Neufs" | "";
  onTransactionTypeChange: (
    item: { value: string, vendu: boolean, label: string, color: string }
  ) => void;
  onMapSearchParamsChange: (
    mapState: RootState["listingsV2"]["mapState"]
  ) => void;
  onPlaceSearchResult: ({
    region,
    province,
    commune,
    zoom,
    lat,
    lng,
    quartier,
    shortName,
  }: {
    region?: string;
    province?: string;
    commune?: string;
    zoom?: any;
    lat?: any;
    lng?: any;
    quartier?: any;
    shortName?: any;
  }) => void;
  onTypesSelected: (types: string[]) => void;
  onPriceRangeChange: ({
    minPrice,
    maxPrice,
  }: {
    minPrice?: number;
    maxPrice?: number;
  }) => void;
  onSurfaceRangeChange: ({
    minSurface,
    maxSurface,
  }: {
    minSurface?: number;
    maxSurface?: number;
  }) => void;
  onTypologieSelect: (typologie: number[]) => void;
  onMeubleeChange: (meublee: boolean) => void;
  onCaracteristicsSelect: (caracteristics: string[]) => void;
  onPlacesAutoCompleteGeolocatePress: () => void;
  onBulkFiltersChange: (filters: {
    types: string[];
    caracteristics: string[];
    typologies: number[];
    minSurface: number | undefined;
    maxSurface: number | undefined;
    meublee: boolean;
    prixmin?: number;
    prixmax?: number;
  }) => void;
  totalListingsCount?: any;
  onMapVsListChange?: any;

  openAuth?: any;
  scrollY?: any;
  mapVsList?: "MAP" | "LIST";
}) {
  const { t, lang } = useTranslation("commonAnnonces");
  const [showSearchInputField, setShowSearchInputField] =
    useState<boolean>(true);
  const searchPayload = useSelector(
    ListingsReducerSelectors.searchPayloadSelector
  );
  const dispatch = useDispatch();
  const onAdressChange = (e) => {
    dispatch(ListingreducerActions.setSearchAdress(e));
  };

  const router = useRouter();
  const isAuthDialogVisibleTrigger = useSelector(
    UserSpaceSelectors.isAuthDialogVisibleSelector
  );
  useEffect(() => {
    if (isAuthDialogVisibleTrigger) {
      setAuthDialogVisible(true);
      dispatch(UserSpaceActions.setIsAuthDialogVisible({ data: false }));
    }
  }, [isAuthDialogVisibleTrigger]);
  const authenticatedRedux = useSelector(
    (store: any) => store?.auth?.authenticated
  );
  const userRedux = useSelector((store: any) => store?.auth?.user);
  const authenticatedProRedux = useSelector(
    (store: any) => store?.auth?.authenticatedPro
  );

  const [user, setUser] = useState(userRedux);
  useEffect(() => {
    setUser(userRedux);
  }, [userRedux]);
  const [activeRoute, setActiveRoute] = useState(router.pathname);

  const [isAuthDialogVisible, setAuthDialogVisible] = useState(false);

  const getNavType = (pathname: string, authenticated: boolean) => {
    // /estimation/appartement/resultat?token=74bd70ea-f86b-4138-abf6-b5cb77ee2d65
    if (pathname.includes("user")) {
      return "NORMAL";
    } else if (pathname.includes("estimation")) {
      //on est dans l 'estimation
      if (!pathname.includes("estimation-")) {
        // on est pas dans la homePage d'estimation => on est dans estimation stepper
        if (pathname.includes("estimation") && pathname.includes("resultat")) {
          // on est dans les resultats
          if (!authenticated) {
            // resultat mais sans authentification

            return "ESTIMATION";
          } else {
            // authentifier => on affiche la navbar normale

            return "NORMAL";
          }
        } else {
          // on est dans estimation/map , estimation/bien ..

          return "ESTIMATION";
        }
      }
    }
    if (
      pathname.startsWith("/offres-pro") ||
      pathname.startsWith("/temoignages")
    ) {
      // on est dans une des pages de l'offre pro
      return "OFFRE_PRO";
    }
    if (
      pathname.startsWith("/espace-pro") ||
      pathname.startsWith("/espace-pro")
    ) {
      // on est dans espace pro => espace pro a son propre Navbar
      return "PRO_SPACE";
    }
    if (pathname.startsWith("/guide-du-credit")) {
      return "CREDIT";
    }
    if (pathname.startsWith("/credit")) {
      return "CREDIT";
    }
    return "NORMAL";
  };

  useEffect(() => {
    setActiveRoute(router.pathname);
  }, [router.pathname]);

  // useEffect(() => {
  //   (function (history) {
  //     var pushState = history.pushState;
  //     history.pushState = function (state) {
  //       if (typeof history.onpushstate == "function") {
  //         history.onpushstate({ state: state });
  //       }
  //       // ... whatever else you want to do
  //       // maybe call onhashchange e.handler

  //       try {
  //         return pushState.apply(history, arguments);
  //       } catch (e) {}
  //     };
  //   })(window.history);
  //   window.onpopstate = history.onpushstate = function (e) {
  //     if (e.state) {
  //       if (e.state.url) {
  //         setActiveRoute(e.state.url);
  //       }
  //     }
  //   };
  // }, []);
  useEffect(() => {
    // if (JSON.stringify(userRedux) !== JSON.stringify(userUpdate.current)) {
    //   userUpdate.current = userRedux;
    checkUserClientSide(undefined, dispatch);
    // }
  }, []);
  const onLogout = () => {
    // dispatch(setAuthenticated({}));
    dispatch(updateUser({ data: null }));
    dispatch(signInR({ data: null }));
    dispatch(setUID({ data: null }));
    dispatch(setEmail({ data: null }));
    dispatch(setUserDispatch({ data: null }));
    localStorage.removeItem("FBIdToken");
    localStorage.removeItem("RT");
    nookies.set(undefined, "AccessToken", "", {
      path: "/",
    });
    nookies.destroy(undefined, "AccessToken");
    nookies.set(undefined, "FBIdToken", "", {
      path: "/",
    });
    nookies.destroy(undefined, "FBIdToken");
    nookies.set(undefined, "RT", "", {
      path: "/",
    });
    nookies.destroy(undefined, "RT");

    dispatch(setUserDispatch(null));
    dispatch(setAuthenticated(false));
  };

  const authenticated = authenticatedRedux || authenticatedProRedux;

  const navBarType = getNavType(activeRoute, authenticated);

  return (
    <>
      <div
        className={`${SearchBarStyle.search_bar_container} ${mapVsList == "MAP" ? SearchBarStyle.search_bar_containerMap : ""
          /*SearchBarStyle.negative_margin*/
          } `}
        id="filters--container"
      // style={
      //   mapVsList == "MAP" ? { display: "none" } : {}
      // }
      >
        <div
          className={`${SearchBarStyle.mobile_hidden} ${SearchBarStyle.autocomplete_input_container} ${SearchBarStyle.positive_margin}`}
        >
          <PlacesAutoCompleteInput
            lang={lang}
            defaultAdress={searchPayload.address}
            onMapSearchParamsChange={onMapSearchParamsChange}
            onPlaceSearchResult={onPlaceSearchResult}
            onGeolocatePress={onPlacesAutoCompleteGeolocatePress}
            showSearchInputField={showSearchInputField}
            specialClassNames={"in_listings"}
            onMapVsListChange={onMapVsListChange}
          />
        </div>
        <div
          className={`${SearchBarStyle.filters_container} ${
            /*SearchBarStyle.positive_margin*/ ""
            } ${SearchBarStyle.newStyle_filters}`}
        >
          <div
            className={SearchBarStyle.filters_item}
            data-tracking="click"
            data-value=""
          >
            <Suspense fallback={<></>}>
              <TransactionTypeSelect
                transactionType={transactionType}
                onTransactionTypeChange={onTransactionTypeChange}
              />
            </Suspense>
          </div>
          {searchPayload.vendu ? (
            null
          ) : (
            <div
              className={`${SearchBarStyle.filters_item} ${SearchBarStyle.item_mobile_hidden}`}
              data-tracking="click"
              data-value=""
            >
              {/* <div className={`${SearchBarStyle.filters_item}`}> */}
              <Suspense fallback={<></>}>
                <PriceRangeSelect
                  transactionType={transactionType}
                  onPriceRangeChange={onPriceRangeChange}
                />
              </Suspense>
            </div>
          )}
          <div
            className={`${SearchBarStyle.filters_item} ${SearchBarStyle.item_mobile_hidden}`}
          >
            <Suspense fallback={<></>}>
              <BienTypeSelect
                transactionType={transactionType}
                onTypesSelected={onTypesSelected}
              />
            </Suspense>
          </div>
          <div
            className={`${SearchBarStyle.filters_item} ${SearchBarStyle.item_mobile_hidden}`}
          >
            <Suspense fallback={<></>}>
              <TypologieSelect
                onTypologieSelect={onTypologieSelect}
                searchPayloadTypologie={searchPayload.typologie}
              />
            </Suspense>
          </div>
          <div
            className={`${SearchBarStyle.filters_item} ${SearchBarStyle.item_mobile_hidden}`}
          >
            <Suspense fallback={<></>}>
              <SurfaceRangeSelect
                transactionType={transactionType}
                onSurfaceRangeChange={onSurfaceRangeChange}
              />
            </Suspense>
          </div>
          {/* <div
              className={`${SearchBarStyle.filters_item} ${SearchBarStyle.item_mobile_hidden}`}
            >
              <Suspense fallback={<></>}>
                <VoirPlusSelect
                />
              </Suspense>
            </div> */}
          <div
            className={`${SearchBarStyle.filters_item} ${SearchBarStyle.item_desktop_hidden}`}
          >
            <Suspense fallback={<></>}>
              <FiltersDialog
                transactionType={transactionType}
                onResetFilters={() => onBulkFiltersChange({
                  types: [],
                  caracteristics: [],
                  typologies: [],
                  minSurface: undefined,
                  maxSurface: undefined,
                  meublee: false,
                  prixmin: 0,
                  prixmax: 0,
                })}
                onValidateFilters={({
                  types, caracteristics, typologies, minSurface, maxSurface, meublee,
                }) => {
                  onBulkFiltersChange({
                    types,
                    caracteristics,
                    typologies,
                    minSurface,
                    maxSurface,
                    meublee,
                  });
                }}
                totalListingsCount={totalListingsCount}
                onSurfaceRangeChange={onSurfaceRangeChange}
                onPriceRangeChange={onPriceRangeChange}
                button={false}
              // className={undefined}
              />
            </Suspense>
          </div>
          <div className={SearchBarStyle.filters_item}>
            <Suspense fallback={<></>}>
              <SaveSearch />
            </Suspense>
          </div>
        </div>
      </div>
    </>
  );
}
